import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import SwipeableViews from "react-swipeable-views";
import useScreen from "../../../providers/screen";
import Ongoing from "./ongoing";
import Previous from "./previous";
import { Div, HeaderContainer } from "./style";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && (
        <Box p={3}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
};

const Orders = (props) => {
  const { screen } = useScreen();

  const { theme } = props;

  const [value, setValue] = useState(0);

  const handleChange = (event, value) => {
    setValue(value);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <Div className={`swip-container h-100 ${screen?.isDesktop && "mt-2"}`}>
      <HeaderContainer theme={theme} isDesktop={screen?.isDesktop}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab
            className={`MuiButtonBase-root-custom ${
              theme.isDarkTheme && "dark"
            }`}
            label="سفارش های فعال"
            {...a11yProps(0)}
          />
          <Tab
            className={`MuiButtonBase-root-custom ${
              theme.isDarkTheme && "dark"
            }`}
            label="سفارش های قبلی"
            {...a11yProps(1)}
          />
        </Tabs>
      </HeaderContainer>
      <SwipeableViews
        axis="x-reverse"
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} className="p-0">
          <Ongoing />
        </TabPanel>
        <TabPanel value={value} index={1} className="p-0">
          <Previous />
        </TabPanel>
      </SwipeableViews>
    </Div>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
  };
};

export default connect(mapStateToProps)(Orders);
